import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    url: String,
    interval: Number,
    autoRefresh: Boolean,
  };

  declare urlValue: string;
  declare intervalValue: number;
  declare hasIntervalValue: boolean;
  declare autoRefreshValue: boolean;

  private timer: number | null = null;

  connect() {
    console.log("CvPoller connected! URL:", this.urlValue);
    if (!this.hasIntervalValue) this.intervalValue = 2000;

    this.startPolling();
  }

  disconnect() {
    this.stopPolling();
  }

  startPolling() {
    this.timer = window.setInterval(() => {
      this.checkStatus();
    }, this.intervalValue);
  }

  stopPolling() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  closeModal() {
    const modal = document.getElementById("weploy-standardise-modal");

    if (modal) {
      modal.remove();
    }

    const event = new CustomEvent("weploy-cv:saved", {
      bubbles: true,
      cancelable: true,
    });
    window.dispatchEvent(event);

    console.log("CvPoller: Event 'weploy-cv:saved' dispatched on window!");
  }

  async checkStatus() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) throw new Error("Network error");

      const data = await response.json();

      let isFinished = false;

      if (this.autoRefreshValue) {
        isFinished = data.status === "approved";
      } else {
        isFinished = data.status === "draft" || data.status === "approved";
      }

      if (isFinished) {
        this.stopPolling();

        if (this.autoRefreshValue) {
          const event = new CustomEvent("weploy-cv:saved", {
            bubbles: true,
            cancelable: true,
          });
          window.dispatchEvent(event);
          return;
        }

        if (data.html) {
          this.element.innerHTML = data.html;
        }
      } else if (data.status === "failed") {
        this.stopPolling();

        const errorMessage = data.error_message || "Unknown system error.";

        this.element.innerHTML = `
          <div class="flex flex-col items-center justify-center h-full text-center p-8">
            <div class="rounded-full bg-red-100 p-3 mb-4">
              <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
              </svg>
            </div>
            <h3 class="text-lg font-medium text-gray-900">AI Parsing Failed</h3>
            
            <div class="mt-2 max-w-md bg-red-50 border border-red-200 rounded p-3">
               <p class="text-sm text-red-800 font-mono break-words">${errorMessage}</p>
            </div>

            <div class="mt-6">
               <button type="button" 
                       data-action="click->organization-app--cv-poller#closeModal"
                       class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                 Close & Try Manual Entry
               </button>
            </div>
          </div>
        `;
        // ----------------------------------------
      }
    } catch (error) {
      console.error("Polling error:", error);
    }
  }
}
